import React from 'react';
import PropTypes from 'prop-types';
import withDraggable from 'withDraggable';
import withResizable from 'withResizable';

const ACTIVE_POPUP_Z_INDEX = 9999;

const withDragAndResize = (WrappedComponent, withDragAndResizeProps = {}) => {
  class WrappedComponentWithDragAndResize extends React.PureComponent {
    render() {
      const {
        style,
        className,
        onMouseDown,
        onMouseUp,
        onTouchStart,
        onTouchEnd,
        isDragging,
      } = this.props;

      let zIndex = this.props.zIndex;
      if (isDragging) {
        zIndex = ACTIVE_POPUP_Z_INDEX;
      }
      // Update transform from translate to translate3d. This fixes an issue
      // on retina displays where popups disappear
      if (this.props.useTranslate3D && !this.props.isDragging) {
        style.transform = `translate3d(${this.props.x}px, ${this.props.y}px, 0px)`;
      }

      return (
        <div
          className={`${className}`}
          id={this.props.id}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onTouchEnd={onTouchEnd}
          onTouchStart={onTouchStart}
          style={{
            ...style,
            position: 'absolute',
            width: this.props.width,
            height: this.props.height,
            zIndex,
          }}
        >
          <WrappedComponent
            {...this.props}
            isDragging={this.props.isDragging}
            resizeHandleComponent={this.props.children}
          />
        </div>
      );
    }
  }

  WrappedComponentWithDragAndResize.defaultProps = {
    children: null,
    className: '',
    id: '',
    isDragging: false,
    style: {},
    useTranslate3D: false,
    zIndex: 1,
  };

  WrappedComponentWithDragAndResize.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    height: PropTypes.number.isRequired,
    id: PropTypes.string,
    isDragging: PropTypes.bool,
    onMouseDown: PropTypes.func.isRequired,
    onMouseUp: PropTypes.func.isRequired,
    onTouchEnd: PropTypes.func.isRequired,
    onTouchStart: PropTypes.func.isRequired,
    style: PropTypes.shape({}),
    useTranslate3D: PropTypes.bool,
    width: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    zIndex: PropTypes.number,
  };

  return withDraggable(
    withResizable(WrappedComponentWithDragAndResize, withDragAndResizeProps.resizeProps || {}),
    {
      dragHandle: '.drag-handle',
      ...withDragAndResizeProps.dragProps,
    },
  );
};

export default withDragAndResize;



// WEBPACK FOOTER //
// ./src-react/withDragAndResize/index.jsx